import css from "./ShowOnHover.module.scss";

// Visibe if not within a hover container or if within a hover container and the hover container is hovered
export const SHOW_ON_HOVER = css.showOnHover;
export const HIDE_ON_HOVER = css.hideOnHover;
export const HOVER_CONTAINER = css.hoverContainer;
export const ALWAYS_SHOW = css.alwaysShow; // Meant to be used with JS to keep showing the element even when the hover container is not hovered
